import * as React from "react";

export function Loader() {
  return <p>Loading...</p>;
}

export default Loader;
